module.exports = __webpack_public_path__ + "static/pic03-054c6828b0ef27716c578de240a93a40.jpg";